import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const customSwitchStyle = css`
  > div {
    background-color: ${theme.colors.primary50};
    border-color: ${theme.colors.primary50};
  }
`;
